/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GreenMachineErrorMutationVariables = {|
  greenMachineSessionID: string,
  error: string,
|};
export type GreenMachineErrorMutationResponse = {|
  +reportGreenMachineError: ?{|
    +success: ?boolean
  |}
|};
export type GreenMachineErrorMutation = {|
  variables: GreenMachineErrorMutationVariables,
  response: GreenMachineErrorMutationResponse,
|};
*/


/*
mutation GreenMachineErrorMutation(
  $greenMachineSessionID: ID!
  $error: String!
) {
  reportGreenMachineError(input: {greenMachineSessionId: $greenMachineSessionID, error: $error}) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "error"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "greenMachineSessionID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "error",
            "variableName": "error"
          },
          {
            "kind": "Variable",
            "name": "greenMachineSessionId",
            "variableName": "greenMachineSessionID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ReportGreenMachineErrorPayload",
    "kind": "LinkedField",
    "name": "reportGreenMachineError",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GreenMachineErrorMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GreenMachineErrorMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4ed26b84043f21f9eef69374cda96dba",
    "id": null,
    "metadata": {},
    "name": "GreenMachineErrorMutation",
    "operationKind": "mutation",
    "text": "mutation GreenMachineErrorMutation(\n  $greenMachineSessionID: ID!\n  $error: String!\n) {\n  reportGreenMachineError(input: {greenMachineSessionId: $greenMachineSessionID, error: $error}) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f99d59eaf274256e135b03c629e2ad24';

module.exports = node;
